<div class="bubble" id="bubble" ></div>

<p-table #table     
    [value]="galleria" 
    responsiveLayout="stack" 
    [breakpoint]="'960px'"
    styleClass="p-datatable-striped" 
    [paginator]="true" 
    [showCurrentPageReport]="true" 
    [rowHover]="true" 
    showGridlines
    [globalFilterFields]="['file']" 
    currentPageReportTemplate="{first} di {last} su {totalRecords} file" 
    [rows]="5" [rowsPerPageOptions]="[5, 10, 20, 50]">
    <ng-template pTemplate="caption">
        <div class="flex lg:flex-row flex-col gap-4 w-full">
            <div class="lg:w-3/4 w-full">
                <span class="block w-full p-input-icon-left">
                    <i class="bi bi-search before:align-super before:content-['\f52a']"></i>
                    <input pInputText type="text" (input)="onGlobalFilter(table, $event)" placeholder="Cerca..." class="w-full indent-6" />
                </span>
            </div>
            <div class="lg:w-1/4 w-full">                    
                <button class="w-full h-full btn-outln-backoffice text-center" type="button" (click)="add = true">                
                    <i class="bi bi-plus"></i>
                    Aggiungi Files Galleria
                </button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th class="w-1/12"></th>
            <th class="w-9/12">File</th>                                                                                    
            <th class="w-2/12"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-file let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td class="text-center">
                <i class="bi bi-list text-4xl hover:text-black" pReorderableRowHandle></i>
            </td>
            <td (mouseover)="setBubbleImage(file)" (mouseleave)="deleteBubbleImage(file)" id="lista">{{file.file}}</td>
            <td class="text-center" *ngIf="!file.file_upload && !file.file_base64">
                <div class="flex flex-row items-center justify-center">                                    
                    <i class="bi bi-pencil text-2xl hover:text-black cursor-pointer" (click)="onOpenEdit(file)" *ngIf="file.type !== 'image'"></i>
                    <p-divider layout="vertical" *ngIf="file.type !== 'image'"></p-divider>                                    
                    <a [href]="file.file_base64 ? file.file_base64 : (file.file + '?type=' + file.type | file)" target="_blank"><i class="bi text-2xl hover:text-black cursor-pointer" [ngClass]="{'bi-card-image': file.type === 'image', 'bi-play-btn': file.type !== 'image' }"></i></a>
                    <p-divider layout="vertical"></p-divider>
                    <p-confirmPopup #deleteGallery>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <p-button class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDelete()" label="Elimina" />
                                    <p-button class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onAnnullaDelete()" label="Annulla" />
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmPopup>
                    <i class="bi bi-trash text-2xl hover:text-black cursor-pointer" (click)="onOpenDelete($event, file, index)"></i>
                </div>
            </td>
            <td class="text-center" *ngIf="file.file_upload || file.file_base64">                
                <i class="bi bi-trash text-2xl hover:text-black cursor-pointer" (click)="onRemoveFileGalleria(file)"></i>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="3">Nessuno file presente nella galleria.</td>
        </tr>
    </ng-template>
</p-table>

<!-- MODAL ADD FILE GALLERIA -->
<p-dialog [visible]="add" [style]="{width: '70%'}" header="Aggiungi files alla galleria" [modal]="true" class="p-fluid" (visibleChange)="onCloseModal();">
    <ng-template pTemplate="content">

        <ng-container *ngIf="!add_files && !add_image">            
            <div class="w-full flex lg:flex-row flex-col gap-4 justify-end mt-4">
                <button type="button" class="btn-outln-backoffice py-3 px-8 font-medium" (click)="add_files = true">Aggiungi uno o più file</button>
                <button type="button" class="btn-outln-backoffice py-3 px-8 font-medium" (click)="add_image = true">Aggiungi un'immagine e seleziona l'area</button>
                <button type="button" class="btn-danger-backoffice py-3 px-8 font-medium" (click)="onCloseModal();">Annulla</button>
            </div>
        </ng-container>
        <div class="flex flex-col gap-4" *ngIf="add_files">
            
            <p-fileUpload mode="advanced" [multiple]="true" chooseLabel="Seleziona un file" accept="image/*, video/*" maxFileSize="1000000000" cancelLabel="Rimuovi" [showUploadButton]="false" (onSelect)="onUpload($event)" (onRemove)="onRemoveUpload($event)" (onClear)="onClearUpload($event)" />                            

            <div class="w-full flex lg:flex-row flex-col gap-4 justify-end">
                <button type="button" class="btn-outln-backoffice py-3 px-8 font-medium" [disabled]="files.length <= 0" (click)="onAddFilesGalleria(files)">Aggiungi</button>
                <button type="button" class="btn-danger-backoffice py-3 px-8 font-medium" (click)="add_files = false">Indietro</button>
                <button type="button" class="btn-danger-backoffice py-3 px-8 font-medium" (click)="onCloseModal();">Annulla</button>
            </div>
        </div>
        <div class="flex flex-col" *ngIf="add_image">
            <app-image-cropper [type]="'box'" [aspect_ratio]="1/1" [height]="550" [width]="450" accept="image/*" label="Seleziona un'immagine" (onCrop)="immagine=$event"></app-image-cropper>

            <div class="w-full flex lg:flex-row flex-col gap-4 justify-end" [ngClass]="{'mt-8': immagine.length > 0}">
                <button type="button" class="btn-outln-backoffice py-3 px-8 font-medium" [disabled]="immagine.length <= 0" (click)="onAddFileGalleria(immagine)">Ritaglia</button>
                <button type="button" class="btn-danger-backoffice py-3 px-8 font-medium" (click)="add_image = false">Indietro</button>
                <button type="button" class="btn-danger-backoffice py-3 px-8 font-medium" (click)="add_image = false; immagine=''">Annulla</button>
            </div>
        </div>
    </ng-template>
</p-dialog>
<!-- MODAL ADD FILE GALLERIA -->

<!-- MODAL EDIT FILE GALLERIA -->
<p-dialog [visible]="edit" [style]="{width: '50%'}" header="Modifica video galleria" [modal]="true" class="p-fluid" (visibleChange)="onCloseModal();">
    <ng-template pTemplate="content">        
        <div class="flex flex-col gap-4">
            
            <form [formGroup]="formGalleria">
                <p-checkbox class="flex justify-center" label="Mostra in evidenza" formControlName="evidenza" value="evidenza" pTooltip="Se selezionato, in caso lo spettacolo sia impostato come in 'evidenzia' verrà mostrato il seguente video al posto della copertina in Home page!" tooltipPosition="top" />
            </form>
            
            <div class="w-full flex lg:flex-row flex-col gap-4 justify-end">
                <button type="button" class="btn-outln-backoffice p-3 px-8 font-medium" (click)="onEdit()">Modifica</button>
                <button type="button" class="btn-danger-backoffice p-3 px-8 font-medium" (click)="onCloseModal();">Annulla</button>
            </div>
        </div>        
    </ng-template>
</p-dialog>
<!-- MODAL EDIT FILE GALLERIA -->